export const SEGMENT_REVENUE_DATA_REQUEST = 'SEGMENT_REVENUE_DATA_REQUEST';
export const SEGMENT_REVENUE_DATA_SUCCESS = 'SEGMENT_REVENUE_DATA_SUCCESS';
export const SEGMENT_REVENUE_DATA_FAILURE = 'SEGMENT_REVENUE_DATA_FAILURE';
export const SEGMENT_REVENUE_CLEAN_DATA = 'SEGMENT_REVENUE_CLEAN_DATA';
